import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.levels, (level) => {
        return (_openBlock(), _createElementBlock("li", {
          key: level.id
        }, [
          _createVNode(_component_router_link, {
            to: '/maths/levels/' + level.id,
            onClick: ($event: any) => (_ctx.$emit('changeLevel', level))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(level.name), 1)
            ]),
            _: 2
          }, 1032, ["to", "onClick"])
        ]))
      }), 128))
    ])
  ]))
}